import { Discussion } from "../../models";

export interface DiscussionListResult {
  discussions: Discussion[];
  discussionCount: { total: number; currentPage: number };
  pages: { total: number; currentPage: number };
}
